module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container"
  }, [_c('h1', {
    staticClass: "ui dividing header"
  }, [_vm._v("Dimmer")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', {
    staticClass: "ui dividing header"
  }, [_vm._v("Examples")]), _vm._v(" "), _c('div', {
    staticClass: "ui six centered grid"
  }, [_c('div', {
    staticClass: "three wide center aligned column centered"
  }, [_c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.changeDimmerVisibility('showBasicDimmer')
      }
    }
  }, [_vm._v("Basic dimmer")]), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned segment basic-dimmer"
  }, [_vm._v("\n                Basic Dimmer\n\n                "), _c('dimmer', {
    attrs: {
      "dimmerId": "basic-dimmer",
      "targetSelector": ".basic-dimmer",
      "showDimmer": _vm.showBasicDimmer
    },
    on: {
      "update:showDimmer": function($event) {
        _vm.showBasicDimmer = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "three wide center aligned column centered"
  }, [_c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.changeDimmerVisibility('showContentDimmer')
      }
    }
  }, [_vm._v("Content dimmer")]), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned segment content-dimmer"
  }, [_vm._v("\n                Content Dimmer\n\n                "), _c('dimmer', {
    attrs: {
      "dimmerId": "content-dimmer",
      "targetSelector": ".content-dimmer",
      "showDimmer": _vm.showContentDimmer
    },
    on: {
      "update:showDimmer": function($event) {
        _vm.showContentDimmer = $event
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('h2', {
    staticClass: "ui inverted icon header"
  }, [_c('i', {
    staticClass: "heart icon"
  }), _vm._v("\n                                SemVue!\n                            ")])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "three wide center aligned column centered"
  }, [_c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.changeDimmerVisibility('showLoadingDimmer')
      }
    }
  }, [_vm._v("Loading dimmer")]), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned segment loading-dimmer"
  }, [_vm._v("\n                Loading Dimmer\n\n                "), _c('dimmer', {
    attrs: {
      "dimmerId": "loading-dimmer",
      "targetSelector": ".loading-dimmer",
      "showDimmer": _vm.showLoadingDimmer
    },
    on: {
      "update:showDimmer": function($event) {
        _vm.showLoadingDimmer = $event
      }
    }
  }, [_c('div', {
    staticClass: "ui text loader"
  }, [_vm._v("Loading")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "three wide center aligned column centered"
  }, [_c('button', {
    staticClass: "ui button",
    on: {
      "click": function($event) {
        _vm.changeDimmerVisibility('showHoverDimmer')
      }
    }
  }, [_vm._v("Hover dimmer")]), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned segment hover-dimmer"
  }, [_vm._v("\n                Hover Dimmer\n\n                "), _c('dimmer', {
    attrs: {
      "dimmerId": "hover-dimmer",
      "targetSelector": ".hover-dimmer",
      "showDimmer": _vm.showHoverDimmer,
      "options": _vm.hoverDimmerOptions
    },
    on: {
      "update:showDimmer": function($event) {
        _vm.showHoverDimmer = $event
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('h2', {
    staticClass: "ui inverted icon header"
  }, [_vm._v("\n                                Hover Here\n                            ")])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "three wide center aligned column centered"
  }, [_c('button', {
    staticClass: "ui button all-paragraphs-button",
    on: {
      "click": function($event) {
        _vm.changeDimmerVisibility('showAllParagraphsDimmer')
      }
    }
  }, [_vm._v("Dimmer all paragraphs")]), _vm._v(" "), _c('dimmer', {
    attrs: {
      "targetSelector": "p",
      "dimmerId": "all-paragraphs-dimmer",
      "showDimmer": _vm.showAllParagraphsDimmer
    },
    on: {
      "update:showDimmer": function($event) {
        _vm.showAllParagraphsDimmer = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('h3', {
    staticClass: "ui dividing header"
  }, [_vm._v("Usage")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h3', {
    staticClass: "ui dividing header"
  }, [_vm._v("Props")]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Dimmer component,\n        "), _c('a', {
    attrs: {
      "href": "https://semantic-ui.com/modules/dimmer.html"
    }
  }, [_vm._v(" you can see all dimmer documentation here")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Is important to put dimmer component inside element which will be dimmed. Unless if you want to dimmer all elements like paragraphs example")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment code"
  }, [_c('pre', [_vm._v("\n        import { Dimmer } from 'semvue';\n\n        export default {\n            components: {\n                Dimmer,\n            },\n        }\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment code"
  }, [_c('pre', [_vm._v("\n        <div class=\"ui center aligned segment content-dimmer\">\n            Content Dimmer\n\n            <dimmer dimmerId=\"content-dimmer\" targetSelector=\".content-dimmer\" :showDimmer.sync=\"showContentDimmer\">\n                <div class=\"content\">\n                    <div class=\"center\">\n                        <h2 class=\"ui inverted icon header\">\n                            <i class=\"heart icon\"></i>\n                            SemVue!\n                        </h2>\n                    </div>\n                </div>\n            </dimmer>\n        </div>\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "ui definition table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("dimmerId")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Is a div id for dimmer")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("showDimmer")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Used to control dimmer visibility")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("targetSelector")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("Selector of element where dimmer should appear (could be #elementId or .element-class)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("curstomClass")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("No")]), _vm._v(" "), _c('td', [_vm._v("String empty")]), _vm._v(" "), _c('td', [_vm._v("Used to put any aditional class inside dimmer div "), _c('br'), _vm._v("\n                    e.g. class=\"ui customClass dimmer\"\n                ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("options")]), _vm._v(" "), _c('td', [_vm._v("Object")]), _vm._v(" "), _c('td', [_vm._v("No")]), _vm._v(" "), _c('td', [_vm._v("Object Empty")]), _vm._v(" "), _c('td', [_vm._v("Overrides component options.\n                    "), _c('a', {
    attrs: {
      "href": "https://semantic-ui.com/modules/dimmer.html"
    }
  }, [_vm._v(" You can see all options here")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5638fbc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DimmerDoc.vue
// module id = 148
// module chunks = 1